import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import FeedbackStateIconError from '@bubble-ui/icon-feedback-state-error';
import FeedbackStateIconErrorWrapper from '@bubble-ui/icon-feedback-state-error-wrapper';
import FeedbackStateIconWarning from '@bubble-ui/icon-feedback-state-warning';
import FeedbackStateIconWarningWrapper from '@bubble-ui/icon-feedback-state-warning-wrapper';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useAnimationControl } from '@bubble-ui/provider-animation-control';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var Label = _ref => {
  var {
    children,
    error,
    id,
    iconBackgroundColorToken,
    iconBackgroundColorTokenArgs,
    iconColorToken,
    iconColorTokenArgs,
    marginTop,
    textColorToken,
    textColorTokenArgs,
    textStyleToken,
    textStyleTokenArgs,
    warning
  } = _ref;
  var designContext = useDesignContext(_objectSpread(_objectSpread({}, defaultColorVariables), defaultTextStyles));
  var {
    disableAnimations
  } = useAnimationControl();
  var {
    labelFeedbackStateIconInnerWrapperStyle,
    labelFeedbackStateIconOuterWrapperStyle,
    textStyle,
    wrapperStyle
  } = getDefaultStyleSheet({
    designContext,
    disableAnimations,
    marginTop,
    textColorToken,
    textColorTokenArgs,
    textStyleToken,
    textStyleTokenArgs
  });
  return /*#__PURE__*/React.createElement(View, {
    id: id,
    style: wrapperStyle
  }, error && /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconOuterWrapperStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconErrorWrapper, {
    colorToken: iconBackgroundColorToken,
    colorTokenArgs: iconBackgroundColorTokenArgs
  }), /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconInnerWrapperStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconError, {
    colorToken: iconColorToken,
    colorTokenArgs: iconColorTokenArgs
  }))), warning && /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconOuterWrapperStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconWarningWrapper, {
    colorToken: iconBackgroundColorToken,
    colorTokenArgs: iconBackgroundColorTokenArgs
  }), /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconInnerWrapperStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconWarning, {
    colorToken: iconColorToken,
    colorTokenArgs: iconColorTokenArgs
  }))), /*#__PURE__*/React.createElement(Text, {
    style: textStyle,
    numberOfLines: 1
  }, children));
};
Label.displayName = 'FieldLabel';
var FieldLabel = withProvisionalOverrideFromContext(Label);
export { FieldLabel };
//# sourceMappingURL=index.js.map